// extracted by mini-css-extract-plugin
export default {"label":"Card_label__sJ63F","card":"Card_card__xaA6y"};